import LinearGradient from '@vx/gradient/build/gradients/LinearGradient';
export default LinearGradient;